export default __webpack_public_path__ + "static/media/diamond-box-light.82606e12.svg";